import React, { useState } from 'react';

import { FormControl, RadioGroup as MuiRadioGroup } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles(() => ({
  fullWidth: {
    width: '100%',
  },
}));

export interface RadioGroupProps {
  className?: string;
  children: React.ReactNode;
  fullWidth?: boolean;
  label?: string;
  onChange: (element: any) => void;
  value?: any;
}

export function RadioGroup(props: RadioGroupProps): JSX.Element {
  const {
    children,
    fullWidth = true,
    label = '',
    onChange,
    value: initialValue = '',
  } = props;

  const [value, setValue] = useState(initialValue);
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
    onChange && onChange(event);
  };

  const radioGroupStyles = clsx(fullWidth && classes.fullWidth);
  const ariaLabelProp = label && { ariaLabel: label };

  return (
    <FormControl className={radioGroupStyles}>
      <MuiRadioGroup {...ariaLabelProp} onChange={handleChange} value={value}>
        {children}
      </MuiRadioGroup>
    </FormControl>
  );
}
